/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PickerDisplayProvider = require('./PictProvider-InputType-PickerDisplay.js');

/** @type {Record<string, any>} */
const _DEFAULT_CONFIGURATION =
{
	ProviderIdentifier: 'MaterialsSamplePickerDisplay',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
	AutoSolveWithApp: false,
};

/**
 * The Sample Read/Print display (beast B5): PickerDisplay plus the one bespoke behavior the legacy
 * MaterialsSampleDisplay carried — a QR-CODE IMAGE prepended beside the display node (the printed form's
 * scannable sample link). Value resolution itself is the base's: `__Record`-first (a created-but-unsaved
 * sample exists ONLY there), then the GUID identity fetch, with the `[QRCode] Name` compound the shared
 * map configures.
 */
class PictProviderInputTypeMaterialsSamplePickerDisplay extends PickerDisplayProvider
{
	/**
	 * @param {Object} pFable @param {Object} [pOptions] @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DEFAULT_CONFIGURATION, pOptions), pServiceHash);
		/** @type {Pict} */
		this.pict;
	}

	/** Paint the display, then prepend the QR image for the resolved sample (non-tabular; once —
	 *  the legacy `appliedQRCodeAlready` latch). */
	async _paint(pView, pInput, pValue, pRowIndex)
	{
		const tmpPainted = await super._paint(pView, pInput, pValue, pRowIndex);
		if (tmpPainted && pValue && pRowIndex == null)
		{
			this._prependQRCodeImage(pView, pInput, pValue);
		}
		return tmpPainted;
	}

	/**
	 * The legacy buildPrependedQRCodeImage, ported: render the sample's QR code as a small figure before
	 * the display node's host column (Read + Print). The sample record comes from the local `__Record`
	 * snapshot — the same source the paint just resolved from; no snapshot (or no QR code) → no image.
	 * @param {object} pView @param {object} pInput @param {any} pValue
	 */
	_prependQRCodeImage(pView, pInput, pValue)
	{
		if (this.appliedQRCodeAlready || !this.pict.providers.QRCodeProvider)
		{
			return;
		}
		const tmpPictForm = this._resolvedPictForm(pInput);
		const tmpIdentity = this._identityField(tmpPictForm);
		const tmpSample = this._localEntityRecords(pView, pInput, null).find((pRecord) => pRecord[tmpIdentity] == pValue);
		if (!tmpSample || !tmpSample.QRCode)
		{
			return;
		}
		const tmpElements = this.pict.ContentAssignment.getElement(this.getDisplayNodeID(pInput.Macro.RawHTMLID));
		if (!tmpElements || tmpElements.length < 1 || typeof tmpElements[0].closest !== 'function')
		{
			return;
		}
		const tmpParentElement = tmpElements[0].closest('.column');
		if (tmpParentElement)
		{
			const tmpFigure = document.createElement('figure');
			tmpFigure.className = 'image mr-2 is-64x64';
			const tmpImage = document.createElement('img');
			tmpImage.src = this.pict.providers.QRCodeProvider.create(tmpSample.QRCode);
			tmpImage.alt = 'QR Code';
			tmpFigure.append(tmpImage);
			tmpParentElement.prepend(tmpFigure);
			tmpParentElement.classList.add('is-flex');
			tmpParentElement.classList.add('is-align-items-center');
			this.appliedQRCodeAlready = true;
		}
	}
}

module.exports = PictProviderInputTypeMaterialsSamplePickerDisplay;

module.exports.default_configuration = _DEFAULT_CONFIGURATION;
